import React, { useContext, useState } from 'react';
import classnames from 'classnames';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import Details from '../../DeviationViews/Details';
import TextualContent from '../../DeviationViews/TextualContent';
import StageBackground from '../../DeviationBackground/StageBackground';
import { useDeviationViewContext } from '../../Context/DeviationViewContext';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import { ScreenSizeContext } from '../../Measured';
import MonetizationStrip from '../../MonetizationStrip';
import UserGiftSaleBanner from '../_partials/UserGiftSaleBanner';
import DesktopLayout from '../_partials/DesktopLayout';
import PanelPopup from '../_partials/PanelPopup';
import s from './DesktopTextualPage.scss';
const DesktopTextualPage = ({ deviation  })=>{
    var _deviation_textContent, _deviation_extended, _deviation_extended1;
    const { isTheater  } = useDeviationViewContext();
    const isLegacyJournal = getDeviationType(deviation) === DeviationTypes.JOURNAL && ((_deviation_textContent = deviation.textContent) === null || _deviation_textContent === void 0 ? void 0 : _deviation_textContent.html.type) === 'writer';
    const isLegacyView = isLegacyJournal && !((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.journalSkinFullwidth);
    const isFullWidthView = isLegacyJournal && ((_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : _deviation_extended1.journalSkinFullwidth);
    const contentClassName = classnames(s['content'], isLegacyView && s['is-legacy-journal'], isFullWidthView && s['is-fullwidth-skin']);
    const { width: screenSize  } = useContext(ScreenSizeContext);
    // we'll force a re-render of the page when a countdown in the offer banner of the monetization strip
    // reaches 0 (onAdoptableSaleEnd). This will update the actionbar to change from the 'make an offer'
    // button to the 'view offers' button to show the sale is over
    const [hasAdoptionEnded, setHasAdoptionEnded] = useState(false);
    return /*#__PURE__*/ React.createElement(DesktopLayout, {
        className: classnames(isTheater && s['theater']),
        deviation: deviation,
        stageContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ArtStage, {
            deviation: deviation
        }), /*#__PURE__*/ React.createElement("div", {
            className: s['strip-tier-promotion-wrapper']
        }, /*#__PURE__*/ React.createElement(MonetizationStrip, {
            className: s['strip-tier-promotion'],
            deviation: deviation,
            onAdoptableSaleEnd: ()=>setHasAdoptionEnded(true)
        })), /*#__PURE__*/ React.createElement("div", {
            className: contentClassName
        }, /*#__PURE__*/ React.createElement(ActionBar, {
            // maintain a key so we can force a re-render
            key: `actionbar-${hasAdoptionEnded}`,
            deviation: deviation
        })), /*#__PURE__*/ React.createElement(PanelPopup, {
            deviation: deviation,
            className: s['large-popover'],
            actionBarType: "primary"
        }), /*#__PURE__*/ React.createElement("div", {
            className: contentClassName
        }, /*#__PURE__*/ React.createElement(TextualContent, {
            deviation: deviation
        }))),
        metaContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Details, {
            className: contentClassName,
            deviation: deviation
        }), /*#__PURE__*/ React.createElement(UserGiftSaleBanner, {
            user: deviation.author
        })),
        backgroundContent: /*#__PURE__*/ React.createElement(StageBackground, {
            deviation: deviation,
            width: Math.max(screenSize, 780)
        }),
        withSecondaryActionBar: true
    });
};
DesktopTextualPage.displayName = 'DesktopTextualPage';
export default DesktopTextualPage;
